import { ApiOptions } from '../../api-options.decorator';
import { ParamsAdapter } from '../../params.adapter';

import { ApiBaseMidBack } from './base';
import { NominationLimitViewModel } from './types/nominationLimitViewModel';

/**
 * @internal
 */
export class ApiMidbackNomination extends ApiBaseMidBack {
  @ApiOptions({ channel: 'userCurves.series.upload', interceptErrors: false, requestType: 'form' })
  uploadNominationUserCurvesSeriesWithLimit(params: ParamsAdapter) {
    return this.post('/nomination/excel', params);
  }

  @ApiOptions({ channel: 'userCurves.series.post', interceptErrors: false })
  postNominationUserCurvesSeries(params: ParamsAdapter) {
    return this.post('/nomination/values', params);
  }

  @ApiOptions({ channel: 'nominationPhysicalLimit', interceptErrors: false })
  getNominationPhysicalLimits(params: ParamsAdapter) {
    return this.post<NominationLimitViewModel[]>('/nomination/limits/search', params);
  }

  @ApiOptions({ channel: 'nominationPhysicalLimit' })
  createNominationPhysicalLimit(params: ParamsAdapter) {
    return this.post<NominationLimitViewModel[]>('/nomination/limits', params);
  }

  @ApiOptions({ channel: 'nominationPhysicalLimit' })
  updateNominationPhysicalLimit(limitId: number, params: ParamsAdapter) {
    return this.patch(`/nomination/limits/${limitId}`, params);
  }
}
